import { BlurView } from 'expo-blur'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useState } from 'react'
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native'

import { useFocusEffect } from 'expo-router'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { usePollingQuery } from '@/hooks/usePollingQuery'

const EMOJIS = ['👑', '👏', '🙌', '🔥', '💃🏻']

const DailyInspirationCard = observer(() => {
  const {
    session: {
      user,
      dailyInspoReaction,
      getInspoReactionsUsingId,
      dailyInspirationalQuoteData,
      reactOnDailyInspirationalQuote
    },
    analytics: { setEvent }
  } = useStore()
  const userId = user?._id.toString()
  const [isEmojiListVisible, setIsEmojiListVisible] = useState(false)

  const handleReaction = async (emoji: string) => {
    if (dailyInspirationalQuoteData?.acf) {
      setEvent(events.homescreen.motivation_engaged, {
        userId,
        content: dailyInspirationalQuoteData.acf.motivational_message,
        emoji_type: emoji,
        day: dailyInspirationalQuoteData.acf.day,
        week: dailyInspirationalQuoteData.acf.week
      })
    }
    setIsEmojiListVisible(false)
    await reactOnDailyInspirationalQuote(emoji)
  }

  usePollingQuery('getInspoReactionsUsingId', getInspoReactionsUsingId, {
    refetchInterval: 3_000
  })

  return (
    <BlurView intensity={84} tint="light" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
      <DS.Frame style={styles.container}>
        <DS.Text variant="Body Medium/Regular" textAlign="center">
          {dailyInspirationalQuoteData?.acf?.motivational_message ?? ''}
        </DS.Text>
      </DS.Frame>
      <View>
        {isEmojiListVisible && (
          <BlurView intensity={80} tint="light" style={styles.handRankings}>
            {EMOJIS.map((item, index) => {
              return (
                <TouchableOpacity key={`${item}-${index}`} onPress={() => handleReaction(item)}>
                  <DS.Text variant="Heading 4/Medium">{item}</DS.Text>
                </TouchableOpacity>
              )
            })}
          </BlurView>
        )}
        <View key="emojiListContainer" style={styles.emojiListContainer}>
          <TouchableOpacity onPress={() => setIsEmojiListVisible(!isEmojiListVisible)}>
            <Image source={require('../home-screen/assets/emoji-icon.png')} style={styles.emojiIcon} />
          </TouchableOpacity>
          {dailyInspoReaction?.map((item) => {
            if (item.count > 0) {
              return (
                <TouchableOpacity
                  onPress={() => handleReaction(item.emoji)}
                  key={`${item}`}
                  style={styles.reactedEmojiContainer}
                >
                  <DS.Text variant="Body Small/Regular">{`${item.emoji} ${
                    item.count > 1 ? item.count : '\b'
                  }`}</DS.Text>
                </TouchableOpacity>
              )
            }
            return null
          })}
        </View>
      </View>
    </BlurView>
  )
})

export default DailyInspirationCard

const styles = StyleSheet.create({
  container: {
    padding: 24,
    borderRadius: 12
  },
  handRankings: {
    marginTop: 16,
    paddingVertical: 16,
    paddingHorizontal: 12,
    gap: 8,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    width: '80%',
    alignSelf: 'center',
    position: 'absolute',
    bottom: 20,
    zIndex: 2,
    overflow: 'hidden'
  },
  reactedEmojiContainer: {
    backgroundColor: DS.palette['Global/White'],
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 6,
    borderRadius: 32,
    marginHorizontal: 5
  },
  emojiIcon: {
    width: 32,
    height: 32
  },
  emojiListContainer: {
    position: 'absolute',
    overflow: 'visible',
    flexDirection: 'row',
    bottom: -15,
    zIndex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  }
})
